// Посилання для різних розмірів екрана
const largeDesktopLink = "https://my.spline.design/alreadymedianew-c0ce97fb5e5d88bef4e5e1a872941528/";

const smallDesktopLink = "https://my.spline.design/alreadymediatablet12001340px-ff9b9aef696dde5ba05cf17c204a846a/";

const tabletLink = "https://my.spline.design/alreadymedianewcopy-4f35877b63f83720a6c6dd80e23151c9/";

const largeMobileLink = "https://my.spline.design/alreadymediamobile7681200px-00c74cf75bc1ae68997a77439897e018/";
const mobileLink = "https://my.spline.design/alreadymedianewcopy-b65460e9948da9f32b45ba3b0565e78f/";


function updateIframeSrc() {
	// Оновлення desktop iframe
	const desktopIframe = document.querySelector('.desktop-dec');
	if (window.matchMedia("(min-width: 1920px)").matches) {
		desktopIframe.src = largeDesktopLink;
	}

	// Оновлення small-desktop iframe
	const smallDesktopIframe = document.querySelector('.small-desktop');

	if (window.matchMedia("(min-width: 1341px) and (max-width: 1919px)").matches) {
		smallDesktopIframe.src = tabletLink;

	} else if (window.matchMedia("(min-width: 1200px) and (max-width: 1340px)").matches) {
		smallDesktopIframe.src = smallDesktopLink;
	}

	// Оновлення mobile iframe
	const mobileIframe = document.querySelector('.mobile');
	if (window.matchMedia("(min-width: 768px) and (max-width: 1199px)").matches) {
		mobileIframe.src = largeMobileLink;
	} else if (window.matchMedia("(max-width: 767px)").matches) {
		mobileIframe.src = mobileLink;
	}
}

// Виклик функції при завантаженні сторінки
updateIframeSrc();

window.addEventListener('resize', updateIframeSrc);
